/**
 * created by li si yi
 * 下载次数统计
 */
import React, {Component} from 'react';
import {Input, Select, Button, DatePicker, Pagination, Modal, Radio, Tabs} from 'antd';
import {Scrollbars} from "react-custom-scrollbars";
import moment from "moment";
import BaseComponent from "../../../../../base/BaseComponent";
import BaseTable from "../../../../components/baseTable/BaseTable";

const {RangePicker} = DatePicker;
const {Search} = Input;
const {TabPane} = Tabs;

export default class Downloads extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            columns: [
                {
                    title: '名称',
                    dataIndex: 'fileName',
                    ellipsis: true,
                    key: 'fileName',
                    render: (text, record) => {
                        return (
                            <div title={text ? text : ''}>
                                {
                                    record.icon ?
                                        <img src={record.icon} style={{
                                            width: 25,
                                            height: 20,
                                            objectFit: 'cover',
                                            marginRight: '10px'
                                        }}/> :
                                        <div style={{width: 25, height: 20, marginRight: '10px'}}/>
                                }
                                {text ? text : ''}
                            </div>
                        )
                    }
                },
                {
                    title: '作者',
                    dataIndex: 'author',
                    key: 'author',
                    width: '250px',
                    ellipsis: true,
                    render: (text) => {
                        return (
                            <span>{text ? text : ''}</span>
                        )
                    }
                },
                {
                    title: '下载次数',
                    dataIndex: 'times',
                    ellipsis: true,
                    key: 'times',
                    width: '250px',
                    render: (text) => {
                        return (
                            <span>{text ? text : ''}</span>
                        )
                    }
                },
            ],
            tabBarList: [
                {
                    key: '1',
                    name: '图片',
                },
                {
                    key: '2',
                    name: '视频',
                },
                {
                    key: '3',
                    name: '音频',
                },
                {
                    key: '4',
                    name: '其他',
                },
            ],
            params: {
                page: 1,  //页数
                size: 10,  //每页数量
                fileName: "",  //模糊查询
                author: "",  //模糊查询
                startTime: moment().month(moment().month()).startOf('month'),   //开始时间
                endTime: moment().month(moment().month()).endOf('month'),  //结束时间
                resourceType: "1",// 类型
            },
            total: 0,//总数
            dataSource: [],//列表数据
            thisTab: '1',
            btnText: "本月",
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getDataSource();
    }

    render() {
        return (
            <div style={{margin: "15px"}}>
                <div style={{
                    backgroundColor: "#fff",
                    width: "100%",
                    maxHeight: 'calc(100vh - 100px)',
                    borderRadius: '5px',
                    // overflow: 'hidden',
                }}>
                    {this.renderTabBar()}
                    <div style={{padding: '24px 32px'}}>
                        {this.renderHeader()}
                    </div>
                    {this.renderContent()}
                </div>
            </div>
        )
    }

    // 选项卡
    renderTabBar = () => {
        return (
            <Tabs onChange={this.changeTabBar} tabBarStyle={{ paddingLeft: "32px" }}>
                {
                    this.state.tabBarList.map((item) => {
                        return (
                            <TabPane tab={item.name} key={item.key} style={{backgroundColor: '#fff'}}/>
                        )
                    })
                }
            </Tabs>
        )
    };
    // 选项卡改变
    changeTabBar = (key) => {
        let {params} = this.state;
        this.state.thisTab = key;
        this.state.params.fileName = "";
        this.state.params.author = "";
        this.state.params.page = 1;
        this.state.params.size = 10;
        this.state.params.resourceType = key;
        this.setState({}, () => {
            this.getDataSource();
        });
    };

    // 头部
    renderHeader() {
        const publicStyle = {marginRight: 20};
        return (
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div style={{display: 'flex'}}>
                    <div style={publicStyle}>
                        <Search
                            placeholder="请输入作者名称"
                            value={this.state.params.author}
                            onChange={(e) => {
                                this.state.params.author = e.target.value;
                                this.setState({})
                            }}
                            onSearch={value => this.userIdOnSearch(value)}
                            style={{width: 200}}
                        />
                    </div>
                    <div style={publicStyle}>
                        <Search
                            placeholder="请输入文件名称"
                            value={this.state.params.fileName}
                            onChange={(e) => {
                                this.state.params.fileName = e.target.value;
                                this.setState({})
                            }}
                            onSearch={value => this.fileOnSearch(value)}
                            style={{width: 200}}
                        />
                    </div>
                    {/*<Button style={publicStyle} type="primary" onClick={() => this.typeChange()}>查询</Button>*/}
                    <Button style={publicStyle} type="primary" onClick={() => this.revert()}>重置</Button>
                </div>
                <div style={{height: 32}} className={'selectedPicker'}>
                    <Radio.Group value={this.state.btnText} onChange={this.handleSizeChange}
                                 style={{marginRight: '10px'}}>
                        <Radio.Button value="本月">本月</Radio.Button>
                        <Radio.Button value="上月">上月</Radio.Button>
                        <Radio.Button value="本年">本年</Radio.Button>
                        <Radio.Button value="去年">去年</Radio.Button>
                    </Radio.Group>
                    <RangePicker
                        getPopupContainer={triggerNode => triggerNode.parentNode}
                        allowClear
                        value={[this.state.params.startTime, this.state.params.endTime]}
                        style={{width: 230}}
                        onChange={this.rangePickerChange}/>
                </div>
                <style>
                    {
                        `
                                 .selectedPicker .ant-calendar-picker-input.ant-input{
                                    background:#f6f8fd;
                                 }
                                 .selectedPicker .ant-calendar-input-wrap .ant-calendar-date-input-wrap .ant-calendar-input {
                                    
                                    width:150px !important;
                                    background:red;
                                 }
                         `
                    }
                </style>
            </div>
        )
    }

    //内容
    renderContent() {
        console.log("this.state.dataSource：  ", this.state.dataSource);
        return (
            <div className={"nullStyle"}>
                <div style={{maxHeight: 'calc(100vh - 304px)', padding: '0px 32px'}}>
                    <Scrollbars autoHeight autoHeightMax={"calc(100vh - 304px)"}>
                        <BaseTable
                            rowKey="id"
                            dataSource={this.state.dataSource}
                            columns={this.state.columns}
                            pagination={false}
                            locale={{emptyText: '暂无数据'}}
                        />
                    </Scrollbars>
                    <style>{`
                    .nullStyle .ant-table-placeholder{
                       display:flex;
                       justify-content: center;
                       align-items: center;
                    //    height:500px;
                       border-bottom:none;
                    }
                `}</style>
                </div>
                {this.renderFooter()}
            </div>
        )
    }

    // 分页
    renderFooter = () => {
        let {params, total} = this.state;
        // 获取当前tab参数
        let {page, size} = params;
        return (
            <div className={'pagination'} >
                <div style={{padding: "0 10px 0"}}>共{total}条数据</div>
                <Pagination
                    showSizeChanger
                    current={page}
                    pageSize={size}
                    total={total}
                    showQuickJumper={true}
                    onChange={(page, pageSize) => this.pageChange(page, pageSize)}
                    onShowSizeChange={(page, pageSize) => this.pageChange(page, pageSize)}
                />
            </div>
        )
    };

    //获取列表数据
    getDataSource = () => {
        let {params} = this.state;
        let body = JSON.parse(JSON.stringify(params));
        if (body.startTime && body.endTime) {
            body.startTime = moment(body.startTime).format('YYYY-MM-DD');
            body.endTime = moment(body.endTime).format('YYYY-MM-DD');
        }
        this.request({
            url: '/cm-sites-storage-management/zykStatistics/DownloadStatistics',
            method: 'get',
            body: body,
            callBack: (res) => {
                console.log("============", res);
                let dataSource = [];
                let total = 0;
                if (res) {
                    dataSource = res.data;
                    total = res.count;
                }
                this.setState({dataSource, total})
            }
        })
    };
    handleSizeChange = e => {
        let {currentActiveKey} = this.state;
        let data = e.target.value;
        let startTime;
        let endTime;
        if (data === "上月") {
            startTime = moment().month(moment().month() - 1).startOf('month');
            endTime = moment().month(moment().month() - 1).endOf('month');
        } else if (data === "去年") {
            startTime = moment().year(moment().year() - 1).startOf('year');
            endTime = moment().year(moment().year() - 1).endOf('year');
            console.log(startTime, endTime);
        } else if (data === "本月") {
            startTime = moment().month(moment().month()).startOf('month');
            endTime = moment().month(moment().month()).endOf('month');
        } else if (data === "本年") {
            startTime = moment().year(moment().year()).startOf('year');
            endTime = moment().year(moment().year()).endOf('year');
            console.log(startTime, endTime);
        }
        this.state.btnText = e.target.value;
        this.state.params.startTime = startTime;
        this.state.params.endTime = endTime;
        this.setState({}, () => {
            this.getDataSource()
        });
    };

    rangePickerChange = (data, dateString) => {
        let startTime = data && data[0] ? data[0].startOf('day') : null;
        let endTime = data && data[1] ? data[1].endOf('day') : null;
        this.state.params.startTime = startTime;
        this.state.params.endTime = endTime;
        this.state.btnText = "";
        this.setState({});
        this.getDataSource();
    };

    //分页
    pageChange(page, pageSize) {
        let {params} = this.state;
        params.page = page;
        params.size = pageSize;
        this.getDataSource();
    }

    //作者名称搜索
    userIdOnSearch(value) {
        // console.log(value);
        let {params} = this.state;
        params.author = value.replace(/[\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7E]+/g, "");
        params.page = 1;
        this.getDataSource();
    }

    //文件名称搜索
    fileOnSearch(value) {
        // console.log(value);
        let {params} = this.state;
        params.fileName = value.replace(/[\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7E]+/g, "");
        params.page = 1;
        this.getDataSource();
    }

    //重置按钮
    revert() {
        this.state.params = {
            page: 1,
            size: 10,
            fileName: "",
            author: "",
            startTime: moment().month(moment().month()).startOf('month'),   //开始时间
            endTime: moment().month(moment().month()).endOf('month'),  //结束时间
            resourceType: this.state.thisTab,
        };
        this.state.btnText = "本月";
        this.setState({});
        this.getDataSource()
    }
}